module.exports = __webpack_public_path__ + "img/qu.4f38f7af.svg";